/* eslint-disable no-console */
/* eslint-disable max-len */
import { CognitoAuth } from 'amazon-cognito-auth-js/dist/amazon-cognito-auth';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { config as AWSConfig } from 'aws-sdk';
// import { Navigate, BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { createBrowserHistory } from 'history';
// import Flow from '../components/Flow';
import appConfig from '../config/app-config.json';

// const history = createBrowserHistory();
createBrowserHistory();

AWSConfig.region = appConfig.region;

// Creates a CognitoAuth instance
const createCognitoAuth = () => {
  const appWebDomain = appConfig.userPoolBaseUri
    .replace('https://', '')
    .replace('http://', '');
  const auth = new CognitoAuth({
    UserPoolId: appConfig.userPool,
    ClientId: appConfig.clientId,
    AppWebDomain: appWebDomain,
    TokenScopesArray: appConfig.tokenScopes,
    RedirectUriSignIn: process.env.REACT_APP_CALL_BACK_URI,
    RedirectUriSignOut: process.env.REACT_APP_SIGN_OUT_URI,
    // RedirectUriSignIn: appConfig.callbackUri,
    // RedirectUriSignOut: appConfig.signoutUri,
  });
  return auth;
};

// Creates a CognitoUserPool instance
const createCognitoUserPool = () =>
  new CognitoUserPool({
    UserPoolId: appConfig.userPool,
    ClientId: appConfig.clientId,
  });

// Creates a CognitoUser instance
const createCognitoUser = () => {
  const pool = createCognitoUserPool();
  return pool.getCurrentUser();
};
// Get the URI of the hosted sign in screen
const getCognitoSignInUri = () => {
  const signinUri = `${appConfig.userPoolBaseUri}/oauth2/authorize?response_type=token&client_id=${appConfig.clientId}&redirect_uri=${process.env.REACT_APP_CALL_BACK_URI}&scope=email%20openid%20profile`;
  return signinUri;

  // const signinUri = "http://localhost:3001/flow"
  // return signinUri

  // window.open("http://localhost:3001/flow",'_self')
  // return(<Flow />)
  // <Router history={history}></Router>

  // return(history.push('/flow'))
  // return (<Navigate to="/flow" />)
};

// Parse the response from a Cognito callback URI (assumed a token or code is in the supplied href). Returns a promise.
const parseCognitoWebResponse = (href) => {
  return new Promise((resolve, reject) => {
    const auth = createCognitoAuth();

    // userHandler will trigger the promise
    auth.userhandler = {
      onSuccess(result) {
        resolve(result);
        // window.open('http://localhost:3001/main', '_self');
        window.open(`${process.env.REACT_APP_CALL_BACK_URI}recent-files-list`, '_self');
        // return(<Navigate to="/flow" />)
        // window.open("http://localhost:3001/flow");
      },
      onFailure(err) {
        reject(new Error(`Failure parsing Cognito web response: ${err}`));
      },
    };
    auth.parseCognitoWebResponse(href);
  });
};

// const route = () => (
//   // <Routes>
//   //     <Route path="/flow" element={<Flow />} />
//   // </Routes>
//   <Navigate to="/flow" />
// );
// Gets a new Cognito session. Returns a promise.
const getCognitoSession = () => {
  return new Promise((resolve, reject) => {
    const cognitoUser = createCognitoUser();
    cognitoUser.getSession((err, result) => {
      if (err || !result) {
        reject(new Error(`Failure getting Cognito session: ${err}`));
        return;
      }
      // return(<Navigate to="/flow" />)
      // Resolve the promise with the session credentials
      // console.debug(`Successfully got session: ${JSON.stringify(result)}`);
      const { given_name = '', family_name = '' } = result.idToken.payload;
      const session = {
        credentials: {
          accessToken: result.accessToken.jwtToken,
          idToken: result.idToken.jwtToken,
          refreshToken: result.refreshToken.token,
          exptime: result.idToken.payload.exp
        },
        user: {
          userName: result.idToken.payload['cognito:username'],
          email: result.idToken.payload.email,
          name: `${given_name} ${family_name}`,
        },
      };
      resolve(session);
      // return session
    });
  });
};

// Sign out of the current session (will redirect to signout URI)
const signOutCognitoSession = () => {
  const auth = createCognitoAuth();
  auth.signOut({ global: true });
};

export default {
  createCognitoAuth,
  createCognitoUser,
  createCognitoUserPool,
  getCognitoSession,
  getCognitoSignInUri,
  parseCognitoWebResponse,
  signOutCognitoSession,
};
